<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="120px" size="mini" style="width: 100%;">
        <div class=" formItemBox">
          <el-form-item label="车牌号:" >
            <el-input  placeholder="" v-model="searchFrom.plate"></el-input>
          </el-form-item>
        </div>
       <div class="searchBtnBox"  >
         <el-form-item v-if="btnFlg[0]">
            <el-button  type="primary" @click="searchFn" >查询</el-button>
        </el-form-item>
        <el-form-item >
          <el-button  type="primary" @click="resetForm('searchFrom')" >重置</el-button>
        </el-form-item>
        <el-form-item v-if="btnFlg[1]">
          <el-button  type="primary" @click="addFn" >新增</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table"  bordersize="mini"  class="tableComent"
        height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
         <el-table-column label="操作"  min-width="100">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" v-if="btnFlg[2]"  @click="delFn(scope.row)">删除</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="plate" label="车牌号" min-width="170" show-overflow-tooltip ></el-table-column>
        <el-table-column property="color" label="车牌颜色">
          <template scope="scope">
            <div>
              <span>{{["蓝色", "黄色", "已上报"][scope.row.color]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="createTime" :formatter="dateTimeFormat" label="创建时间" min-width="170" ></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align: right">
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog  title="新增"  :close-on-click-modal="false"  :close-on-press-escape="false"  class="jiaoyan"  :visible.sync="dialogVisible"  @close="closeDialog"  width="470px"  center >
      <div>
        <el-form  :model="addFrom"  :rules="rules"  ref="addFrom" class="demo-form-inline "   label-width="140px"  size="mini" >
          <div class="addinpBox">
            <el-form-item label="车牌号:" prop="plate">
              <el-input   maxlength="50"  :validate-event="false"  placeholder  v-model="addFrom.plate"  ></el-input>
            </el-form-item>
            <el-form-item label="车牌颜色:" prop="color">
              <el-select placeholder="请选择" v-model="addFrom.color">
                  <el-option label="蓝色" :value="0" ></el-option>
                  <el-option label="黄色" :value="1" ></el-option>
                </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false" size="mini">取消</el-button>
        <el-button type="primary" size="mini" @click="saveFn('addFrom')" >保存</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { hmdList, hmdAdd, hmdDelete } from '@/api/vgs-driver'
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  inject: ['reload'],
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: false,
      total: 0,
      dialogVisible: false,
      addFrom: { },
      isAdd: {},
      rules: {
        plate: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ],
        color: [
          { required: true, message: '请选择车牌颜色', trigger: 'blur' }
        ]
      },
      isDisable: false,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00BM0I0100', '00BM0I0200', '00BM0I0300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/SysOperationLog')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
    this.$emit('update:mianbaoxie', 'Home / System Manage / Dict ')
  },
  methods: {

    addFn () {
      this.addFrom = { }
      this.dialogVisible = true
    },

    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'loading...'
          })
          hmdAdd(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: 'loading...'
        })
        hmdDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },

    // 查询
    searchFn () {
      this.getList()
    },
    // 获取列表
    getList () {
      hmdList(this.searchFrom).then(res => {
        if (res) {
          this.tableList = res.list
          this.total = res.total
        } else {
          this.tableList = []
          this.total = 0
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.addFrom = {}
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}

.addinpBox .el-input{
  width: 193px;
}

</style>
